var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('div',{staticClass:"prism-player",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.playerId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }